import { type JSX, Show } from "solid-js";
import { twMerge } from "tailwind-merge";
import { ProcessingSpinner } from "../../ui";

interface BlockHeaderPillProps {
  title: string;
  icon: JSX.Element;
  isProcessing: boolean;
  onClick: () => void;
  variant?: "blue" | "purple";
}

export const BlockHeaderPill = (props: BlockHeaderPillProps) => {
  const variant = () => props.variant || "blue";

  const getVariantClasses = () => {
    switch (variant()) {
      default:
        return {
          pill: "bg-panel hover:bg-panel-hover text-primary-text border border-muted-border",
          spinner: "border-secondary-text border-2",
        };
    }
  };

  return (
    <div class="relative flex items-center gap-2">
      <button
        type="button"
        onClick={props.onClick}
        class={twMerge(
          "inline-flex max-w-full min-w-0 items-center gap-2 rounded-full px-3 py-2 text-xs font-medium transition-all",
          getVariantClasses().pill,
          props.isProcessing && "animate-pulse"
        )}
        title={`Click to view: ${props.title}`}
      >
        <span class="shrink-0 text-brand opacity-70">{props.icon}</span>
        <span class="truncate">{props.title}</span>
        <Show when={props.isProcessing}>
          <ProcessingSpinner class="size-3 border-[1.5px] border-secondary-text" />
        </Show>
      </button>
    </div>
  );
};
